import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Vietnamese ID generator following Single Responsibility Principle
 */
export class VnGenerator extends BaseGenerator {
  generate(options = {}) {
    const { birthYear = null, gender = null } = options;

    // Province code (3 digits) - common Vietnamese province codes
    const provinceCodes = ['001', '002', '004', '006', '008', '010', '011', '012', '014', '015'];
    const provinceCode = provinceCodes[this.randomInt(0, provinceCodes.length - 1)];

    // Gender and century code (1 digit)
    let genderCentury;
    if (gender === 'male') {
      genderCentury = this.randomInt(0, 1) ? '0' : '2'; // Male codes
    } else if (gender === 'female') {
      genderCentury = this.randomInt(0, 1) ? '1' : '3'; // Female codes
    } else {
      genderCentury = this.randomInt(0, 3).toString();
    }

    // Birth year (2 digits)
    const year = birthYear ? birthYear.toString().slice(-2) : this.padZero(this.randomInt(0, 99), 2);

    // Random sequence (6 digits)
    const sequence = this.randomDigits(6);

    return provinceCode + genderCentury + year + sequence;
  }
}